export const CHECKOUT_URL = "https://interceptive-en.impultienda.ar/checkout/";

export const MOCKUP_URL =
  "https://cdn.magicpatterns.com/uploads/jhKSvDQdexiHoTcg9mb3YW/MOCKUP_INTERCEPTIVE-EN.png";

export const AUTHOR_PHOTO_URL =
  "https://cdn.magicpatterns.com/uploads/b2123WS4eUCbdDNvCS5qPw/VALERIA_MONTES_-_BIOMECANICA.png";
